import React, { useEffect, useState } from "react";
import { api } from "../../lib/apiClient";
import { MarketSummaryChart } from "../n1/MarketSummaryChart";

export function KitMarketSummary({ caseId }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get(`/cases/${caseId}/kit/market`).then((r) => setData(r.data)).catch(() => setData(null));
  }, [caseId]);
  if (!data?.available || !data.comparables?.some((c) => c.valor_cop > 0)) return null;
  return (
    <section className="mt-6 mb-6 border border-gray-200 bg-white p-6" data-testid="kit-market-summary">
      <p className="text-[11px] uppercase tracking-widest text-primary font-medium mb-3">Kit Documental v{data.kit_version} · Análisis del sector</p>
      <MarketSummaryChart comparables={data.comparables} budget={data.budget_cop} />
    </section>
  );
}
